// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=none,ts_nocheck=true"
// @generated from file pull_requests/v1/file_metadata.proto (package github.pull_requests.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { ChangeType } from "./file_tree_pb";
import { file_pull_requests_v1_file_tree } from "./file_tree_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file pull_requests/v1/file_metadata.proto.
 */
export const file_pull_requests_v1_file_metadata: GenFile = /*@__PURE__*/
  fileDesc("CiRwdWxsX3JlcXVlc3RzL3YxL2ZpbGVfbWV0YWRhdGEucHJvdG8SF2dpdGh1Yi5wdWxsX3JlcXVlc3RzLnYxIu8BChRGaWxlTWV0YWRhdGFSZXNwb25zZRIQCghiYXNlX3NoYRgBIAEoCRIQCghoZWFkX3NoYRgCIAEoCRI4CgVmaWxlcxgDIAMoCzIpLmdpdGh1Yi5wdWxsX3JlcXVlc3RzLnYxLkZpbGVNZXRhZGF0YUZpbGUSPAoHY29tbWl0cxgEIAMoCzIrLmdpdGh1Yi5wdWxsX3JlcXVlc3RzLnYxLkZpbGVNZXRhZGF0YUNvbW1pdBI7CgZjb3VudHMYBSABKAsyKy5naXRodWIucHVsbF9yZXF1ZXN0cy52MS5GaWxlTWV0YWRhdGFDb3VudHMilQIKEEZpbGVNZXRhZGF0YUZpbGUSOAoLY2hhbmdlX3R5cGUYASABKA4yIy5naXRodWIucHVsbF9yZXF1ZXN0cy52MS5DaGFuZ2VUeXBlEgwKBHBhdGgYAiABKAkSEwoLbGluZXNfYWRkZWQYAyABKAUSFQoNbGluZXNfY2hhbmdlZBgEIAEoBRIVCg1saW5lc19kZWxldGVkGAUgASgFEhgKEGlzX21hbmlmZXN0X2ZpbGUYBiABKAgSEwoLaXNfdmVuZG9yZWQYByABKAgSEwoLcGF0aF9kaWdlc3QYCCABKAkSEgoKaXNfc3ltbGluaxgJIAEoCBIeChZkaWZmX2NvbnRlbnRfY2FjaGVfa2V5GAogASgJIpMBChJGaWxlTWV0YWRhdGFDb21taXQSEwoLYWN0b3JfbG9naW4YASABKAkSLgoKY3JlYXRlZF9hdBgCIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXASGAoQbWVzc2FnZV9oZWFkbGluZRgDIAEoCRILCgNvaWQYBCABKAkSEQoJc2hvcnRfb2lkGAUgASgJImYKEkZpbGVNZXRhZGF0YUNvdW50cxINCgVmaWxlcxgBIAEoBRITCgtsaW5lc19hZGRlZBgCIAEoBRIVCg1saW5lc19kZWxldGVkGAMgASgFEhUKDWxpbmVzX2NoYW5nZWQYBCABKAViBnByb3RvMw", [file_google_protobuf_timestamp, file_pull_requests_v1_file_tree]);

/**
 * Response payload for
 * GET /:owner/:repo/pull/:number/file_metadata/:base_sha/:head_sha
 *
 * Defined by PullRequests::PageData::FileMetadataController#show.
 *
 * @generated from message github.pull_requests.v1.FileMetadataResponse
 */
export type FileMetadataResponse = Message<"github.pull_requests.v1.FileMetadataResponse"> & {
  /**
   * @generated from field: string base_sha = 1;
   */
  baseSha: string;

  /**
   * @generated from field: string head_sha = 2;
   */
  headSha: string;

  /**
   * @generated from field: repeated github.pull_requests.v1.FileMetadataFile files = 3;
   */
  files: FileMetadataFile[];

  /**
   * @generated from field: repeated github.pull_requests.v1.FileMetadataCommit commits = 4;
   */
  commits: FileMetadataCommit[];

  /**
   * @generated from field: github.pull_requests.v1.FileMetadataCounts counts = 5;
   */
  counts?: FileMetadataCounts;
};

/**
 * Describes the message github.pull_requests.v1.FileMetadataResponse.
 * Use `create(FileMetadataResponseSchema)` to create a new message.
 */
export const FileMetadataResponseSchema: GenMessage<FileMetadataResponse> = /*@__PURE__*/
  messageDesc(file_pull_requests_v1_file_metadata, 0);

/**
 * @generated from message github.pull_requests.v1.FileMetadataFile
 */
export type FileMetadataFile = Message<"github.pull_requests.v1.FileMetadataFile"> & {
  /**
   * @generated from field: github.pull_requests.v1.ChangeType change_type = 1;
   */
  changeType: ChangeType;

  /**
   * @generated from field: string path = 2;
   */
  path: string;

  /**
   * @generated from field: int32 lines_added = 3;
   */
  linesAdded: number;

  /**
   * @generated from field: int32 lines_changed = 4;
   */
  linesChanged: number;

  /**
   * @generated from field: int32 lines_deleted = 5;
   */
  linesDeleted: number;

  /**
   * @generated from field: bool is_manifest_file = 6;
   */
  isManifestFile: boolean;

  /**
   * @generated from field: bool is_vendored = 7;
   */
  isVendored: boolean;

  /**
   * @generated from field: string path_digest = 8;
   */
  pathDigest: string;

  /**
   * @generated from field: bool is_symlink = 9;
   */
  isSymlink: boolean;

  /**
   * @generated from field: string diff_content_cache_key = 10;
   */
  diffContentCacheKey: string;
};

/**
 * Describes the message github.pull_requests.v1.FileMetadataFile.
 * Use `create(FileMetadataFileSchema)` to create a new message.
 */
export const FileMetadataFileSchema: GenMessage<FileMetadataFile> = /*@__PURE__*/
  messageDesc(file_pull_requests_v1_file_metadata, 1);

/**
 * @generated from message github.pull_requests.v1.FileMetadataCommit
 */
export type FileMetadataCommit = Message<"github.pull_requests.v1.FileMetadataCommit"> & {
  /**
   * @generated from field: string actor_login = 1;
   */
  actorLogin: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 2;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: string message_headline = 3;
   */
  messageHeadline: string;

  /**
   * @generated from field: string oid = 4;
   */
  oid: string;

  /**
   * @generated from field: string short_oid = 5;
   */
  shortOid: string;
};

/**
 * Describes the message github.pull_requests.v1.FileMetadataCommit.
 * Use `create(FileMetadataCommitSchema)` to create a new message.
 */
export const FileMetadataCommitSchema: GenMessage<FileMetadataCommit> = /*@__PURE__*/
  messageDesc(file_pull_requests_v1_file_metadata, 2);

/**
 * @generated from message github.pull_requests.v1.FileMetadataCounts
 */
export type FileMetadataCounts = Message<"github.pull_requests.v1.FileMetadataCounts"> & {
  /**
   * @generated from field: int32 files = 1;
   */
  files: number;

  /**
   * @generated from field: int32 lines_added = 2;
   */
  linesAdded: number;

  /**
   * @generated from field: int32 lines_deleted = 3;
   */
  linesDeleted: number;

  /**
   * @generated from field: int32 lines_changed = 4;
   */
  linesChanged: number;
};

/**
 * Describes the message github.pull_requests.v1.FileMetadataCounts.
 * Use `create(FileMetadataCountsSchema)` to create a new message.
 */
export const FileMetadataCountsSchema: GenMessage<FileMetadataCounts> = /*@__PURE__*/
  messageDesc(file_pull_requests_v1_file_metadata, 3);

import { registerSchemaHash } from "../../../schema-hash-registry";
registerSchemaHash(FileMetadataResponseSchema, "ddac28169590")
registerSchemaHash(FileMetadataFileSchema, "a5461b998582")
registerSchemaHash(FileMetadataCommitSchema, "7dd6bc128563")
registerSchemaHash(FileMetadataCountsSchema, "64b350924581")
